import React from 'react';
import FolderOutlinedIcon from '@mui/icons-material//FolderOutlined';
import { TableCell, TableRow, Typography } from '@mui/material';
import { useStylesCurrentRequestedDocumentTableFolderRow } from './styles';

const RootFolderIconRow = ({ isSubFolder = false }: { isSubFolder: boolean }) => {
  const rootFolderIconClasses = useStylesCurrentRequestedDocumentTableFolderRow({ isSubFolder });

  return (
    <TableRow>
      <TableCell colSpan={7}>
        <div className={rootFolderIconClasses.folder}>
          <FolderOutlinedIcon className={rootFolderIconClasses.icon} />
          <Typography className={rootFolderIconClasses.folderText} variant="subtitle1">
            /
          </Typography>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default RootFolderIconRow;
